import { utcToZonedTime } from 'date-fns-tz';
import { subDays, startOfDay, isValid } from 'date-fns';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import map from 'lodash/map';
// import { DealsOfTheDayScanned } from '../../api/database/models/dealsOfTheDay';
import { CustomBlogPostUser, DealPostType, FeedObjectType } from '@types';
import { PageDeal } from '../../api/database/models/pageDeal';

export const getCommonBackground = (
  backgroundColor: string,
  isDarkMode: boolean
) => {
  return {
    backgroundColor,
    margin: '0px -16px',
    padding: '10px 17px',
    border: isDarkMode ? `1px solid transparent` : `1px solid #bdc6ca`
  };
};

const getPostDate = (postDate: string | null) => {
  // if this is a valid time
  if (postDate && isValid(new Date(postDate))) {
    return new Date(postDate).toISOString();
  }
  return new Date().toISOString();
};

export const postDataToFeedObj = (data: DealPostType[]): FeedObjectType[] => {
  const feedObj: FeedObjectType[] = [];

  forEach(data, (deal) => {
    const { dateFirstActive, title, brand } = deal;
    const dealObjType = 'ASIN-deal';

    // Check if the brand already exists in the feedObj
    const existingBrandObj =
      brand && find(feedObj, (obj) => obj.brand === brand);

    if (existingBrandObj) {
      // If the brand exists, add this deal to the relatedDeals of that brand
      existingBrandObj.relatedDeals.push(deal);
    } else {
      // If the brand doesn't exist, add a new object to the main feedObj array
      feedObj.push({
        dealObj: deal,
        dealObjType,
        postDate: getPostDate(dateFirstActive),
        title,
        brand,
        permalink: `${deal.slug}`,
        relatedDeals: []
      });
    }
  });

  return feedObj;
};

// export const bestSellingToFeedObj = (): FeedObjectType => {
//   const today = new Date();

//   const pstDate = utcToZonedTime(today, 'America/Los_Angeles');

//   pstDate.setHours(5, 30, 0, 0); // Set hours to 5:30am PST

//   // Format the date as a string
//   const postDate = pstDate.toISOString();

//   const feedObj = {
//     dealObj: 'best-selling-week',
//     dealObjType: 'best-selling-week',
//     postDate,
//     title: `Best Selling Deals of the Past Week`,
//     permalink: `best-selling-week`
//   };

//   return feedObj;
// };

export const daysToFeed = (days: number): FeedObjectType[] => {
  const feedObj = map(getPacificMidnightsUTC(days), (day) => {
    const dealObjType = 'day-bar';
    const postDate = day;
    const isPostDateInFuture = new Date(postDate) > new Date();

    if (isPostDateInFuture) {
      return null;
    }

    return {
      dealObj: day,
      dealObjType,
      postDate,
      title: ``,
      permalink: `day-bar-${day}`
    };
  });

  return feedObj;
};

export const pageDealsToFeedObjs = (data: PageDeal[]): FeedObjectType[] => {
  const feedObj = map(data, (deal) => {
    const dealObjType = 'page-deal';
    const { postDate, menuTitle, slug } = deal;
    const isPostDateInFuture = new Date(postDate) > new Date();

    if (isPostDateInFuture) {
      return null;
    }

    return {
      dealObj: deal,
      dealObjType,
      postDate,
      title: `${menuTitle}`,
      permalink: `page-deal-${slug}`
    };
  });

  return feedObj;
};

export const customBlogPostsToFeedObj = (
  data: CustomBlogPostUser[]
): FeedObjectType[] => {
  const feedObj = map(data, (deal) => {
    const dealObjType = 'custom-blog-post';
    const { publishedAt, title, slug } = deal;
    const isPostDateInFuture = new Date(publishedAt) > new Date();

    if (isPostDateInFuture) {
      return null;
    }

    return {
      dealObj: deal,
      dealObjType,
      postDate: publishedAt,
      title: `${title}`,
      permalink: `${slug}`
    };
  });

  return feedObj;
};

const getPacificMidnightsUTC = (days: number): string[] => {
  const timeZone = 'America/Los_Angeles';

  return Array.from({ length: days }, (_, index) => {
    // Get date `index` days ago
    const date = subDays(new Date(), index);

    // Convert to start of the day in the Pacific timezone
    const pacificMidnight = utcToZonedTime(startOfDay(date), timeZone);

    // Convert to its UTC representation and format it
    return pacificMidnight.toISOString();
  }).reverse();
};
